import Application from "../../Application";
import { ILocaleProvider } from "./LocaleProvider";
import { ILanguageService } from "../language/LanguageService";

export interface IAsyncLocaleProvider extends ILocaleProvider {
  fetch(languageCode: number): Promise<any>;
}

const AsyncLocaleProvider = (
  application: Application,
  languageService: ILanguageService
): IAsyncLocaleProvider => {
  const _application = application;
  let _localeDictionary: any = {};

  return {
    getCurrentLanguage() {
      return _application.container.resolve<number>("language");
    },
    addLocale(locale: number, translations: any) {
      _localeDictionary[locale] = translations;
    },
    changeCurrentLanguage(languageCode: number) {
      _application.changeSystemLanguage(languageCode);
    },
    async fetch(languageCode: number) {
      let translations = languageService.getLanguage(languageCode);
      return translations;
    },
    get translations() {
      const language = _application.container.resolve<number>("language");
      return _localeDictionary[language];
    }
  };
};

export default AsyncLocaleProvider;
